module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('canvas', {
    ref: "avatarEditorCanvas",
    staticClass: "cursorPointer",
    attrs: {
      "width": _vm.canvasWidth,
      "height": _vm.canvasHeight,
      "id": "avatarEditorCanvas"
    },
    on: {
      "dragover": function($event) {
        $event.preventDefault();
      },
      "drop": _vm.onDrop,
      "mousedown": _vm.onDragStart,
      "touchstart": _vm.onDragStart,
      "click": _vm.clicked
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": _vm.accept
    },
    on: {
      "change": _vm.fileSelected
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e7a7d9d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-avatar-editor-improved/src/components/VueAvatar.vue
// module id = 948
// module chunks = 2 4 5